import BaseEvent from './BaseEvent';
import highlightEvent, { SessionMode } from './HighlightEvent';
/***
 * !IMPORTANT
 * Dont instantiate this class for sending custom analytics events.
 * As this class uses window.KhazadDumBridge.logEvent method provided by sdk
 * and in SDK, analytics events send with eventName = 'custom_glance_event' is being dropped,
 * as there is no mapping of eventName = 'custom_glance_event' in SDK.
 *
 * Mappings present in SDK:
 * HIGHLIGHTS_EVENT, BUBBLE_EVENT, IMPRESSION_EVENT, EVENT_FOLLOW_CREATOR,
 * APP_SHORTCUT, POCKET_MODE_EVENT_TYPE, INTEREST_COLLECTION
 *
 * So for sending custom analytics use:
 * pingCustomAnalytics method present in glanceandroidinterface.ts
 * which internally uses - window.GlanceAndroidInterface.sendCustomAnalyticsEvent
 */
class CustomGlanceEvent extends BaseEvent {
    constructor(glanceId, impressionId, eventType, extras) {
        super();
        this.impressionType = 'bubble';
        this.sessionId = highlightEvent.highlightsSessionId;
        this.mode = SessionMode.HIGHLIGHTS;
        this.gpid = '';
        this.eventName = "custom_glance_event" /* CUSTOM */;
        this.glanceId = glanceId;
        this.impressionId = impressionId;
        this.eventType = eventType;
        this.extras = extras;
    }
    toJSON() {
        return {
            impressionType: 'bubble',
            sessionId: highlightEvent.highlightsSessionId,
            mode: SessionMode.HIGHLIGHTS,
            gpid: '',
            glanceId: this.glanceId,
            impressionId: this.impressionId,
            eventType: this.eventType,
            extras: this.extras,
            eventName: this.eventName,
        };
    }
    reset() {
        throw new Error('Method not implemented.');
    }
}
export default CustomGlanceEvent;
//# sourceMappingURL=CustomGlanceEvent.js.map